import React from 'react';
import Box from '../Box/Box';
import Icon from '../Icon/Icon';
import { TIcon } from '../../types/TStyleVariables';
import { TextBodySmall } from '../Text';

type TAttribute = {
  icon: TIcon;
  title: string;
  description: string;
  typedValue?: string;
  onSuggestionFill?: () => void;
};

const renderTitle = (title: string, typedValue?: string) => {
  const searchValue = typedValue?.trim();
  if (!searchValue) {
    return title;
  }

  const matchIndex = title.toLowerCase().indexOf(searchValue.toLowerCase());

  if (matchIndex === -1) {
    return title;
  }

  const before = title.slice(0, matchIndex);
  const remainder = title.slice(matchIndex + searchValue.length);
  const leadingWhitespace = remainder.match(/^\s+/)?.[0] ?? '';

  return (
    <>
      {before && (
        <TextBodySmall as="strong" className="hz-MultilineAttribute-boldSuggestions">
          {before}
        </TextBodySmall>
      )}
      {title.slice(matchIndex, matchIndex + searchValue.length)}
      {leadingWhitespace}
      <TextBodySmall as="strong" className="hz-MultilineAttribute-boldSuggestions">
        {remainder.slice(leadingWhitespace.length)}
      </TextBodySmall>
    </>
  );
};

const MultilineAttribute = ({ icon, title, description, typedValue, onSuggestionFill, ...rest }: TAttribute) => (
  <Box {...rest} as="div" name="MultilineAttribute">
    <Icon name={icon} />
    <Box as="div" name={onSuggestionFill ? 'wrapQuery' : 'wrap'} parent="MultilineAttribute">
      <Box as="p" name="title" parent="MultilineAttribute">
        {renderTitle(title, typedValue)}
      </Box>
      <Box as="p" name="description" parent="MultilineAttribute">
        {description}
      </Box>
    </Box>
    {onSuggestionFill && (
      <Box
        as="span"
        name="queryBuilder"
        parent="MultilineAttribute"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onSuggestionFill();
        }}
      >
        <Icon name="arrow-tailed-up" color="background-brand-core" />
      </Box>
    )}
  </Box>
);

export default MultilineAttribute;
